// Entorno en el que corre la web, según el proyecto de Firebase con que se compiló (build-proyecto.mjs).
const env = import.meta.env;

/** Etiqueta junto al logo: "DEV" en el proyecto de pruebas, "LOCAL" con emuladores; null en producción. */
export const ETIQUETA_ENTORNO: string | null =
  env.DEV && env.VITE_USAR_EMULADORES === 'true' ? 'LOCAL' : /-dev$/.test(env.VITE_FIREBASE_PROJECT_ID ?? '') ? 'DEV' : null;
